module.exports = __webpack_public_path__ + "img/jardin12.292bf0cb.jpg";